export default "__VITE_ASSET__DoDSRp28__"